var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbarSuggestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61,
    fill: "none",
    viewBox: "0 0 62 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D5DD",
    strokeWidth: 2,
    d: "M57 27C57 12.64 45.36 1 31 1S5 12.64 5 27"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 27,
    r: 26,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 27,
    r: 24.5,
    fill: "#fff",
    stroke: "#1E0AF5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "m42.402 19.364 1.932-5.697-5.697 1.932-4.82-3.598.077 6.015-4.911 3.473 5.744 1.786 1.785 5.744 3.473-4.911 6.015.076-3.598-4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "m33.02 24.982-2.308-.717L16.626 38.35a2.137 2.137 0 0 0 3.023 3.023l14.086-14.087-.716-2.304Zm.916 7.718-1.51 1.51 1.51 1.512 1.511-1.511-1.51-1.511Zm9.888-3.682-1.511 1.511 1.51 1.512 1.512-1.512-1.511-1.51ZM23.25 22.726l-1.512 1.51 1.512 1.512 1.511-1.511-1.511-1.511Zm4.1-9.435-1.51 1.511 1.51 1.512 1.512-1.512-1.511-1.511Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 12h30v30H16z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 62,
    height: 61,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5511_74946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5511_74946",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbarSuggestionIcon);
export default __webpack_public_path__ + "static/media/chatbar-suggestion-icon.9c0fb9ae4c3f9168f53018b1dfa7cba7.svg";
export { ForwardRef as ReactComponent };